var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.salaryRow)?_c('b-modal',{attrs:{"id":"calculationInformationModal","title":_vm.dialogTitle,"size":"lg","ok-only":""}},[_c(_vm.salaryRow.calculation,{tag:"component",attrs:{"calculationData":_vm.calculationData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }